module.exports = __webpack_public_path__ + "img/Profesional.9742ed8b.svg";